const BLOCKED_LEAD_STAGES = new Set(["spam", "unqualified", "lost"]);

const normalizeStageName = (row) =>
  String(
    row?.lead_stage_name ??
      row?.lead_stage?.lead_stage_name ??
      row?.leadStage?.lead_stage_name ??
      ""
  )
    .trim()
    .toLowerCase();

const isSpamLead = (row) =>
  row?.is_spam === true ||
  row?.is_spam === 1 ||
  row?.is_spam === "1" ||
  String(row?.is_spam || "").trim().toLowerCase() === "true";

/** Returns a user-facing message when enrollment must be blocked, else null. */
export const getLeadEnrollmentBlockMessage = (row) => {
  if (!row || typeof row !== "object") return null;

  const stageName = normalizeStageName(row);

  if (BLOCKED_LEAD_STAGES.has(stageName)) {
    const label = stageName.charAt(0).toUpperCase() + stageName.slice(1);
    return `This lead is marked as ${label} and cannot be enrolled.`;
  }

  if (isSpamLead(row)) {
    return "This lead is marked as Spam and cannot be enrolled.";
  }

  return null;
};

export const isLeadEnrollmentBlocked = (row) =>
  Boolean(getLeadEnrollmentBlockMessage(row));

export const filterLeadsForStudentEnrollment = (leads, { keepLeadId } = {}) =>
  (Array.isArray(leads) ? leads : []).filter((lead) => {
    const leadId = lead?.organization_ems_lead_id ?? lead?.id;
    if (
      keepLeadId !== undefined &&
      keepLeadId !== null &&
      String(keepLeadId).trim() !== "" &&
      String(leadId) === String(keepLeadId)
    ) {
      return true;
    }
    return !isLeadEnrollmentBlocked(lead);
  });
